<template>
  <BaseDialog centered contentClass="delete-normalized-name" ref="dialog" persistent show-actions>
    <template slot="title">{{ $t('page.admin-tenant.normalized-names.delete-dialog.title') }}</template>
    <template slot="content">
      <span v-if="normalizedName">{{
        $t('page.admin-tenant.normalized-names.delete-dialog.description', { name: normalizedName.normalizedName })
      }}</span>
      <div class="delete-normalized-name__actions">
        <BaseButton is-outlined class="delete-normalized-name__cancel" @click.native="cancelClick">{{
          $t('actions.cancel')
        }}</BaseButton>
        <BaseButton @click.native="execute">
          <span>{{ $t('actions.delete') }}</span>
        </BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseDialog from '@/components/base/BaseDialog';
import { mapActions } from 'vuex';

export default {
  name: 'DeleteNormalizedNameDialog',
  components: {
    BaseButton,
    BaseDialog,
  },
  data() {
    return { normalizedName: null };
  },
  methods: {
    ...mapActions('biDashboard', ['deleteTenantNormalizedName']),

    open(normalizedName) {
      this.normalizedName = normalizedName;
      this.$refs.dialog.openModal();
    },
    close() {
      this.normalizedName = null;
      this.$refs.dialog.isModalOpen = false;
    },
    execute() {
      this.deleteTenantNormalizedName(this.normalizedName.id)
        .then(() => {
          this.$toast.success(
            this.$t('page.admin-tenant.normalized-names.delete-dialog.delete-normalized-name-success'),
          );
        })
        .catch((error) => this.$toast.error(error));
      this.close();
    },
    cancelClick() {
      this.close();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__delete-normalized-name {
  min-height: 150px;
  max-height: 650px !important;
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }
  .close-icon__container {
    display: none;
  }
}

.delete-normalized-name {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }

  &__action {
    text-transform: lowercase;
    font-weight: bold;
  }
}
</style>
